import * as Formatter from "../utils/Formatter"
import { toNumber, get, isEmpty } from "lodash"
import { TW } from "../tw/const/constValue"

export const GetAttribute = (
  securityType: number,
  symbol: string,
  exchange: number,
  elementGroup: string,
  dataPush = true
) => {
  const _ticket = GetTicket(securityType, symbol, exchange, elementGroup)
  return { "data-symbol": _ticket, "data-push": dataPush }
}

export const GetTicket = (
  securityType: number,
  symbol: string,
  exchange: number,
  elementGroup: string
) => {
  return Formatter.format(
    "{0}@{1}",
    InternalGetTicketKey(toNumber(securityType), symbol, toNumber(exchange)),
    InternalGetElementGroup(securityType, symbol, elementGroup)
  )
}

const InternalGetElementGroup = (
  securityType: number,
  symbol: string,
  elementGroup: string
) => {
  if (securityType === TW.SECURITY_TYPE.INDEX && symbol === "101") {
    return "NK225Index"
  }
  return elementGroup
}

export function GetTicketKey(obj: any) {
  return obj && isEmpty(obj) === false
    ? InternalGetTicketKey(
        toNumber(get(obj, "SecurityType")),
        get(obj, "Symbol"),
        toNumber(get(obj, "Exchange"))
      )
    : ""
}

const InternalGetTicketKey = (
  securityType: number,
  symbol: string,
  exchange: number
) => {
  const securityCode = (secT => {
    switch (secT) {
      case TW.SECURITY_TYPE.INDEX: //指数
        return "N"
      case TW.SECURITY_TYPE.EQUITY.JAPAN: //株
        return "E"
      case TW.SECURITY_TYPE.EQUITY.US: //米株
        return "USE"
      case TW.SECURITY_TYPE.EQUITY.HONG_KONG:
        return "HKE"
      case TW.SECURITY_TYPE.EQUITY.CHINA:
        return "CNE"
      case TW.SECURITY_TYPE.EQUITY.TAIWAN:
        return "TWE"
      case TW.SECURITY_TYPE.EQUITY.KOREA:
        return "KRE"
      case TW.SECURITY_TYPE.EQUITY.SINGAPORE:
        return "SGE"
      case TW.SECURITY_TYPE.EQUITY.THAILAND:
        return "THE"
      case TW.SECURITY_TYPE.EQUITY.MALAYSIA:
        return "MYE"
      case TW.SECURITY_TYPE.EQUITY.INDONESIA:
        return "IDE"
      case TW.SECURITY_TYPE.EQUITY.PHILIPPINES:
        return "PHE"
      case TW.SECURITY_TYPE.EQUITY.VIETNAM:
        return "VNE"
      case TW.SECURITY_TYPE.EXCHANGE:
        return "FX"
      case TW.SECURITY_TYPE.BOND.THAILAND:
        return "THGB"
      case TW.SECURITY_TYPE.BOND.CHINA:
        return "CNGB"
      case TW.SECURITY_TYPE.BOND.JAPAN:
        return "JPGB"
      case TW.SECURITY_TYPE.BOND.HONG_KONG:
        return "HKGB"
      case TW.SECURITY_TYPE.BOND.US:
        return "USGB"
      case TW.SECURITY_TYPE.BOND.SOUTH_AFRICA:
        return "ZAGB"
      case TW.SECURITY_TYPE.BOND.KOREA:
        return "KRGB"
      case TW.SECURITY_TYPE.BOND.VIETNAM:
        return "VNGB"
      case TW.SECURITY_TYPE.BOND.RUSSIA:
        return "RUGB"
      case TW.SECURITY_TYPE.BOND.PHILIPPINES:
        return "PHGB"
      case TW.SECURITY_TYPE.BOND.INDONESIA:
        return "IDGB"
      case TW.SECURITY_TYPE.BOND.TAIWAN:
        return "TWGB"
      case TW.SECURITY_TYPE.BOND.ENGLAND:
        return "GBGB"
      case TW.SECURITY_TYPE.BOND.MALAYSIA:
        return "MYGB"
      case TW.SECURITY_TYPE.BOND.EURO:
        return "EUGB"
      case TW.SECURITY_TYPE.BOND.GERMANY:
        return "DEGB"
      case TW.SECURITY_TYPE.BOND.FRANCE:
        return "FRGB"
      case TW.SECURITY_TYPE.BOND.SINGAPORE:
        return "SGGB"
      case TW.SECURITY_TYPE.BOND.NEW_ZEALAND:
        return "NZGB"
      case TW.SECURITY_TYPE.BOND.AUSTRALIA:
        return "AUGB"
      case TW.SECURITY_TYPE.BOND.BRAZIL:
        return "BRGB"
      case TW.SECURITY_TYPE.FUTURE.NK225: //NK225 先物
      case TW.SECURITY_TYPE.FUTURE.TOPIX: //TOPIX 先物
      case TW.SECURITY_TYPE.FUTURE.NK225_MINI: //NK225ミニ 先物
      case TW.SECURITY_TYPE.FUTURE.TOPIX_MINI: //TOPIXミニ 先物
        return "G"
      case TW.SECURITY_TYPE.OPTION.NK225: //NK225 オプション
        return "R"
      case TW.SECURITY_TYPE.POLICY_INTEREST_RATE:
        return "PIR"
      case TW.SECURITY_TYPE.INDICATORS:
        return "EI"
      case TW.SECURITY_TYPE.COMMODITY.GOLD:
      case TW.SECURITY_TYPE.COMMODITY.SILVER:
        return "CS"
      case TW.SECURITY_TYPE.COMMODITY.GOLD_NY_FUTURE:
      case TW.SECURITY_TYPE.COMMODITY.SILVER_NY_FUTURE:
        return "CME"
      case TW.SECURITY_TYPE.COMMODITY.PLATINUM_NY_FUTURE:
      case TW.SECURITY_TYPE.COMMODITY.PALLADIUM_NY_FUTURE:
      case TW.SECURITY_TYPE.COMMODITY.WTI_CRUDE_OIL_FUTURE:
        return "NME"
      case TW.SECURITY_TYPE.COMMODITY.LONDON_GOLD_FIXING:
        return "LL"
      case TW.SECURITY_TYPE.NK225_FUTURE_CME:
        return "USG"

      default:
        return ""
    }
  })(securityType)

  const exchangeCode = (ex => {
    switch (ex) {
      case TW.EXCHANGE.TSE:
        return "T"
      case TW.EXCHANGE.OSE:
        return "O"
      case TW.EXCHANGE.NSE:
        return "M"
      case TW.EXCHANGE.FSE:
        return "FK"
      case TW.EXCHANGE.SSE:
        return "S"
      case TW.EXCHANGE.OSE_DERIVE_DAY:
        return "OD"
      case TW.EXCHANGE.OSE_DERIVE_NIGHT:
        return "OE"
      case TW.EXCHANGE.NY:
        return "USNY"
      case TW.EXCHANGE.NASDAQ:
        return "USNAS"
      case TW.EXCHANGE.BRAZIL_INDEX:
        return "BRN"
      case TW.EXCHANGE.HONG_KONG_EQUITY:
        return "HK"
      case TW.EXCHANGE.HONG_KONG_INDEX:
        return "HKN"
      case TW.EXCHANGE.SHANGHAI:
        return "CNSH"
      case TW.EXCHANGE.SHENZHEN:
        return "CNSZ"
      case TW.EXCHANGE.TAIWAN_EQUITY:
        return "TW"
      case TW.EXCHANGE.TAIWAN_INEDX:
        return "HKN"
      case TW.EXCHANGE.KOSPI:
        return "KRPI"
      case TW.EXCHANGE.KOSDAQ:
        return "KRDAQ"
      case TW.EXCHANGE.KOREA_INDEX:
        return "KRN"
      case TW.EXCHANGE.SINGAPORE_EQUITY:
        return "SG"
      case TW.EXCHANGE.SINGAPORE_INDEX:
        return "SGN"
      case TW.EXCHANGE.THAILAND_EQUITY:
        return "TH"
      case TW.EXCHANGE.THAILAND_INDEX:
        return "THN"
      case TW.EXCHANGE.MALAYSIA_EQUITY:
        return "MY"
      case TW.EXCHANGE.MALAYSIA_INDEX:
        return "MYN"
      case TW.EXCHANGE.INDONESIA_EQYITY:
        return "ID"
      case TW.EXCHANGE.INDONESIA_INDEX:
        return "IDN"
      case TW.EXCHANGE.PHILIPPINES_EQUITY:
        return "PH"
      case TW.EXCHANGE.PHILIPPINES_INDEX:
        return "PHN"
      case TW.EXCHANGE.HO_CHI_MINH:
        return "VNHC"
      case TW.EXCHANGE.HANOI:
        return "VNHN"
      case TW.EXCHANGE.VIETNAM_INDEX:
        return "VNN"
      case TW.EXCHANGE.ISRAEL_EQUITY:
        return "IL"
      case TW.EXCHANGE.ISRAEL_INDEX:
        return "ILE"
      case TW.EXCHANGE.INDEIA_INDEX:
        return "INN"
      case TW.EXCHANGE.EXCHANGE:
        return "E"
      case TW.EXCHANGE.BOND:
        return "GB"
      case TW.EXCHANGE.POLICY_INTEREST_RATE:
        return "PIR"
      case TW.EXCHANGE.INDICATORS:
        return "EI"
      case TW.EXCHANGE.CS:
        return "CS"
      case TW.EXCHANGE.USF:
        return "CME"
      case TW.EXCHANGE.NME:
        return "NME"
      case TW.EXCHANGE.LONDON_GOLD_FIXING:
        return "LL"
      case TW.EXCHANGE.NK225_FUTURE_CME:
        return "CMENK"
      default:
        return ""
    }
  })(exchange)
  return Formatter.format("*@{0}@{1}@{2}", securityCode, symbol, exchangeCode)
}
